module.exports = __webpack_public_path__ + "static/media/image_1.15f3c3ea.png";